import { ProjectType } from '@/shared/types/api';

export const getParentProjectType = (projectType: ProjectType) => {
  switch (projectType) {
    case 'subproject_client':
      return 'project';
    case 'subproject_contractor':
      return 'subproject_client';
    default:
      return projectType;
  }
};
